export enum ThirdPartyType {
  Consultant = 'consultant',
  ManagedService = 'managed_service',
  Outsource = 'outsource',
  Partner = 'partner',
  Supplier = 'supplier',
}
